export const PASSWORD_PATTERN = /(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+|~\\\-=`{}\[\]:";'<>?,./])/;
export const PHONE_PATTERN = /^\+([0-9\s\-]{7,})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/;
export const EMAIL_PATTERN = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
export const NAME_PATTERN = /^[\p{L}\p{M}\s]+$/u;
export const COMPANY_NAME_PATTERN =
  /^(?=.*\p{L})[\p{L}\p{N}\p{M}](?:[\p{L}\p{N}\p{M}\s&.,'()\-]{0,98}[\p{L}\p{N}\p{M}.,')])?$/u;
